// ToolRegistry.js
// Canonical home of the agent tool registry (moved out of components/Misc/Synapse).
// Every tool registered here must be documented in docs/comprehend-live.md.
export class ToolsRegistry {
  constructor() {
    // Store the tool definitions in a Map keyed by tool name.
    this.tools = new Map();
  }

  /**
   * Adds or updates a tool definition.
   * If a tool with the same name exists, it will be replaced.
   * @param {Object} tool - A tool definition. Must include a `name` property.
   */
  addTool(tool) {
    if (!tool.name) {
      throw new Error('Tool must have a name property');
    }
    this.tools.set(tool.name, tool); // Replaces if already exists
  }

  /**
   * Removes a tool by name.
   * @param {string} toolName - The tool's name.
   */
  removeTool(toolName) {
    this.tools.delete(toolName);
  }

  /**
   * Retrieves a tool by name.
   */
  getTool(toolName) {
    return this.tools.get(toolName);
  }

  /**
   * Returns an array of tool definitions, stripping out the internal handler functions.
   */
  getAllTools() {
    return Array.from(this.tools.values()).map(({ handler, ...rest }) => rest);
  }

  /**
   * Generates the session update payload to notify the realtime API of current tools.
   */
  getSessionUpdatePayload() {
    return {
      type: 'session.update',
      session: {
        tools: this.getAllTools(),
        tool_choice: 'auto',
      },
    };
  }
}
